import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class CallToActonV1 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return <div className="ltn__call-to-action-area call-to-action-6 before-bg-bottom" style={{marginTop:"-20%"}} >
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-12">
			        <div className="call-to-action-inner call-to-action-inner-6 ltn__secondary-bg position-relative text-center---">
			          <div className="coll-to-info text-color-white">
			            <h2>Vous cherchez l'appartement de vos rêves ?</h2>
			            <p>Chez Medesco, nous transformons vos rêves  en réalité.</p>
			          </div>
			          <div className="btn-wrapper go-top">
			            <a className="btn btn-effect-3 btn-white" href="#contact">N'hésitez pas à nous contacter <i className="icon-next" /></a>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default CallToActonV1